import { render, staticRenderFns } from "./SmLabelValueDisplay.vue?vue&type=template&id=38290740&scoped=true&"
import script from "./SmLabelValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./SmLabelValueDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SmLabelValueDisplay.vue?vue&type=style&index=0&id=38290740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38290740",
  null
  
)

export default component.exports